import { GameGrid } from './components/GameGrid';
import { GameDndProvider } from './components/GameControls/GameDnd';
import { LevelProvider } from './hooks/useLevel/provider';

export type HexGameProps = {
  [key: string]: any;
};

export function HexGame(props: HexGameProps) {
  const { config } = props;
  const { pieces, board } = config;

  return (
    <GameDndProvider>
      <LevelProvider pieces={pieces} board={board}>
        <GameGrid config={config} />
      </LevelProvider>
    </GameDndProvider>
  );
}
